import { Col, Row } from "react-bootstrap"
import Message from "../../components/Message"
import './Creditztype.css'
const MoreDetails = ({ setFurthur , furthurDetails, detailsFieldsErr}) => {
    return (

        <div
            className="card border-0 rounded-xl shadow-xs bg-primary"
            id="grad"
        >
            <div
                style={{
                    textAlign: "center",
                    marginTop: "10px",
                    paddingTop: "5px",
                }}
            >
                <h5 className="fs-20 fw-bold mb-0" style={{ color: "white" }}>
                    Furthur Details                </h5>
            </div>
            <br></br>
            
            
            <Row style={{ marginTop: '20px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Release Date</h5> </Col>
                <Col md='5' sm='12'>

                    <input
                        type="text"
                        className="form-control form-control"
                        name="releasedate"
                        onChange={(e) => setFurthur('release', e.target.value)}
                        value={furthurDetails.releaseDate}
                    /></Col>
            </Row>
            <br></br>
            <Row style={{ marginBottom: '20px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Copyright Owner</h5> </Col>
                <Col md='5' sm='12'> <input
                    type="text"
                    className="form-control form-control"
                    name="copyright"
                    onChange={(e) => setFurthur('copyright', e.target.value)}
                    value={furthurDetails.Copyright}

                /></Col>
            </Row>
        </div>
    )


}
export default MoreDetails